var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',{staticClass:"mb-3 word-bold",class:_vm.titleNoprint},[_c('font-awesome-icon',{staticClass:"mr-2",attrs:{"icon":_vm.titIcon}}),_vm._v(" "+_vm._s(_vm.titText)+" ")],1),_c('hr',{class:_vm.titleNoprints})])}
var staticRenderFns = []

export { render, staticRenderFns }